import { render, staticRenderFns } from "./Corporativo.vue?vue&type=template&id=53e8329a&"
import script from "./Corporativo.vue?vue&type=script&lang=js&"
export * from "./Corporativo.vue?vue&type=script&lang=js&"
import style0 from "./Corporativo.vue?vue&type=style&index=0&id=53e8329a&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports